import { useEffect } from 'react';
import { M, useAnimate } from '@/utils/Motion';
import { promptLogin } from '@/services/app/mcd';
import { Login as LoginLayout } from '@CS/routes';

type LoginProps = {
  onLogin: () => Promise<void>;
  onError?: (error: Error) => void;
};

const LoginMotion = M.create(LoginLayout);

export const Login = ({ onLogin, onError }: LoginProps) => {
  const [scope, animate] = useAnimate();

  useEffect(() => {
    animate(
      'section > :nth-child(1)',
      { translate: '0 0', opacity: 1 },
      { duration: 0.4, delay: 0.0 }
    );

    animate(
      'section > :nth-child(2)',
      { translate: '0 0', opacity: 1 },
      { duration: 0.4, delay: 0.2 }
    );

    animate(
      'section > :nth-child(3)',
      { translate: '0 0', opacity: 1 },
      { duration: 0.4, delay: 0.4 }
    );
  }, [animate]);

  const onClick = () =>
    void promptLogin()
      .then(() => onLogin())
      .catch((error: Error) => onError?.(error));

  return <LoginMotion ref={scope} onLogin={onClick} />;
};
